@import 'drinks/drinks-theme';
@import "output1/output1-theme";
@import "grinder/grinder-theme";
@import "milk-steamer/milk-steamer-theme";
@import "parameters/parameters-theme";
@import "modal/modal-theme";

$editor-box-border: '#3E4E5D' !default;
$editor-divider-color: '#111C27' !default;
$editor-header-color: '#B6CEE2' !default;
$editor-header-icon-color: 'inherit' !default;
$editor-output-toggle-background:'transparent' !default;
$editor-output-toggle-color:'#a0b6ca' !default;
$editor-output-toggle-border:'#3e4e5d' !default;
$editor-output-toggle-text-stroke:'#223041' !default;
$editor-output-delete-button-color:'#b5cde1' !default;
$editor-output-delete-button-border:'#3e4e5d' !default;
$editor-output-delete-button-background:'#223041' !default;



@mixin header {
  color: #{$editor-header-color};
}

.header {
  @include header;
  .fa-info-circle {
    color: #{$editor-header-icon-color},
  }
  .delete-button{
    button {
      border: 2px solid #{$editor-output-delete-button-border};
      color: #{$editor-output-delete-button-color};
      background-color: #{$editor-output-delete-button-background};
    }
  }
}

// styles for divider starts here

.box {
  border: 2px solid #{$editor-box-border};
  background: #223041;
  .vertical-divider {
    background-color: #{$editor-divider-color};
  }
}

// Styles for divider ends here

.header {
  .toggle-btn {
    background: #{$editor-output-toggle-background};
    color: #{$editor-output-toggle-color};
    border: 2px solid #{$editor-output-toggle-border};
    -webkit-text-stroke: 2px #{$editor-output-toggle-text-stroke};
    //dark theme
    /* background: transparent;
     -webkit-text-stroke: 2px #223041;
     color: #a0b6ca;
     border: 2px solid #3e4e5d;*/
  }

}





// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/recipe/editor/editor-theme.scss